"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceAfp = exports.addAfp = exports.editAFPFailure = exports.editAFPSuccess = exports.editAFPRequest = void 0;

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.promise.js");

require("regenerator-runtime/runtime.js");

var _index = _interopRequireDefault(require("axios/index"));

var _transformAxiosError = _interopRequireDefault(require("@evdy/web-etc/dist/lib/transformAxiosError"));

var _constants = require("../../constants");

var types = _interopRequireWildcard(require("../../constants/dash/editAfp"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var instance = _index.default.create({
  baseURL: _constants.API_URL
});

var editAFPRequest = function editAFPRequest() {
  return {
    type: types.EDIT_AFP_REQUEST
  };
};

exports.editAFPRequest = editAFPRequest;

var editAFPSuccess = function editAFPSuccess(_ref) {
  var data = _ref.data;
  return {
    data: data,
    receivedAt: Date.now(),
    type: types.EDIT_AFP_SUCCESS
  };
};

exports.editAFPSuccess = editAFPSuccess;

var editAFPFailure = function editAFPFailure(error) {
  return {
    error: error,
    receivedAt: Date.now(),
    type: types.EDIT_AFP_FAILURE
  };
};

exports.editAFPFailure = editAFPFailure;

var addAfp = function addAfp(locationId, userId) {
  return function (dispatch) {
    dispatch(editAFPRequest());
    return instance.post("/auth/funeral-home/".concat(locationId, "/afp/").concat(userId, "?method=add")).then(function (res) {
      return dispatch(editAFPSuccess(res.data));
    }).catch(function (error) {
      return dispatch(editAFPFailure((0, _transformAxiosError.default)(error)));
    });
  };
};

exports.addAfp = addAfp;

var replaceAfp = function replaceAfp(locationId, currentAgentId, newAgentId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = {
                newAgentId: newAgentId,
                currentAgentId: currentAgentId,
                locationId: locationId
              };
              dispatch(editAFPRequest()); // replace agent with new agent

              _context.next = 4;
              return instance.post("/private/memorial/change-afp", _objectSpread({}, data)).catch(function (error) {
                return dispatch(editAFPFailure((0, _transformAxiosError.default)(error)));
              });

            case 4:
              return _context.abrupt("return", instance.post("/auth/funeral-home/".concat(locationId, "/afp/").concat(currentAgentId, "?method=remove")).then(function (res) {
                return dispatch(editAFPSuccess(res.data));
              }).catch(function (error) {
                return dispatch(editAFPFailure((0, _transformAxiosError.default)(error)));
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.replaceAfp = replaceAfp;